export default __webpack_public_path__ + "static/media/bg-masthead-3-800w.88bf9dd9.jpg";